export default __webpack_public_path__ + "static/media/logo.f1fe34be.jpg";